import { render } from "./StockByPhysicalBranch.vue?vue&type=template&id=5f9d198f&scoped=true"
import script from "./StockByPhysicalBranch.vue?vue&type=script&lang=js"
export * from "./StockByPhysicalBranch.vue?vue&type=script&lang=js"

import "./StockByPhysicalBranch.vue?vue&type=style&index=0&id=5f9d198f&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9d198f"]])

export default __exports__